import { render, staticRenderFns } from "./BlockUpload.vue?vue&type=template&id=55e0b437&"
import script from "./BlockUpload.vue?vue&type=script&lang=js&"
export * from "./BlockUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports